import React from 'react';

interface IFormHeader {
    title: string;
}

const FormSection: React.FC<IFormHeader> = (props) => {
    return (
        <fieldset style={{ border: 0, borderTop: '1px solid #6393C1', padding: '.5rem 0', marginTop: '.5rem' }}>
            <legend style={{ fontWeight: 'bold', color: '#6393C1', padding: '0 .5rem', margin: '.5rem 0 .5rem 1rem' }}>{props.title}</legend>
            {props.children}
        </fieldset>
    );
};

export default FormSection;



// WEBPACK FOOTER //
// ./src/components/controls/forms/common/FormSection.tsx